import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './Routes';
import { Provider } from 'react-redux';
import store from './redux/store';
import registerServiceWorker from './registerServiceWorker';

    ReactDOM.render(
        <Provider store={store}>
          <React.Fragment>
            <Routes />
          </React.Fragment>
        </Provider>,
    document.getElementById('root')
);

registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js